import { localeChain } from '@cloud/shared/i18n/locale'
import type { DayPickerLocale } from 'react-day-picker'
import { de, enGB, fr, nl } from 'react-day-picker/locale'

const BY_CODE: Record<string, DayPickerLocale> = {
  'nl-NL': nl,
  'de-DE': de,
  'fr-FR': fr,
  'en-GB': enGB,
}

/**
 * De kalendertaal bij een app-taal, langs de terugvalketen (`nl-BE` → `nl-NL` → `en-GB`). Zonder
 * deze toonde de kalender Engelse maanden en begon de week op zondag, als in de VS (audit
 * 2026-09-28). De taal draagt ook het begin van de week (`options.weekStartsOn`).
 */
export function dayPickerLocale(code: string | null | undefined): DayPickerLocale {
  for (const c of localeChain(code)) {
    const hit = BY_CODE[c]
    if (hit) return hit
  }
  return enGB
}
